// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"ki-z","landingPageVideo":"li-z","play":"mi-z","iframeVideo":"ni-z","playHidden":"oi-z","fullwidth":"pi-z"};